<div class="astrea-box astrea-cart-summary mb-3">
    <div *ngIf="physicalBooks.length > 0" class="astrea-table">
        <div class="astrea-cart-msg mb-2">
            <h3>
                {{ 'cart.physical.title' | translate }}
            </h3>
            <p class="d-flex flex-column">
                {{ 'cart.physical.text1' | translate }}
                {{ 'cart.physical.text2' | translate }}
                {{ 'cart.physical.text3' | translate }}
            </p>
        </div>
        <table class="w-100">
            <tr>
                <th>{{ 'books.details.code' | translate }}</th>
                <th>{{ 'books.details.title' | translate }}</th>
                <th>{{ 'cart.item.units' | translate }}</th>
                <th>{{ 'books.details.pricing' | translate }}</th>
            </tr>
            <tr *ngFor="let b of physicalBooks">
                <td>{{ b.bookInfo.bookcode }}</td>
                <td>{{ b.bookInfo.title }}</td>
                <td>x{{ b.cartInfo.count }}</td>
                <td>
                    {{ pricingService.getCurrency() }}{{ (pricingService.getWebPricing(b.bookInfo) * b.cartInfo.count) | astreaCurrency }}
                </td>
            </tr>
            <tr *ngIf="(shipmentService.getShipment(totalPhysical) | async)">
                <td>-</td>
                <td>{{ 'cart.physical.shipment_cost' | translate }}</td>
                <td>x1</td>
                <td>
                    {{ pricingService.getCurrency() }}{{ (shipmentService.getShipment(totalPhysical) | async) }}
                </td>
            </tr>
        </table>
        <div class="t-right mt-3">
            <p><strong>{{ 'cart.total' | translate }}: </strong>{{ pricingService.getCurrency() }}{{ (shipmentService.getShipmentAndTotal(totalPhysical) | async) }}</p>
            <button (click)="handleChangeTab(2)" class="btn btn-green btn-purchase mt-2" mat-button>
                {{ isLoggedIn ? ('cart.tabs.physical' | translate) : ('cart.logout' | translate) }}
            </button>
        </div>
    </div>

    <hr *ngIf="physicalBooks.length > 0 && digitalBooks.length > 0">

    <div *ngIf="digitalBooks.length > 0" class="astrea-table">
        <div class="astrea-cart-msg mb-2">
            <h3>
                {{ 'cart.digital.title' | translate }}
            </h3>
            <p>
                {{ 'cart.digital.text1' | translate }} <a href="https://astreavirtual.com" target="_blank" title="Astrea Virtual">Astrea Virtual</a> {{ 'cart.digital.text2' | translate }}
            </p>
            <div class="d-flex j-c-start a-i-center mt-1">
                <mat-icon>help_outline</mat-icon>
                <p>
                    {{ 'cart.digital.text3' | translate }}
                </p>
            </div>
        </div>
        <table class="w-100">
            <tr>
                <th>{{ 'books.details.code' | translate }}</th>
                <th>{{ 'books.details.title' | translate }}</th>
                <th>{{ 'cart.item.months' | translate }}</th>
                <th>{{ 'books.details.pricing' | translate }}</th>
            </tr>
            <tr *ngFor="let b of digitalBooks">
                <td>{{ b.bookInfo.bookcode }}</td>
                <td>{{ b.bookInfo.title }}</td>
                <td>x{{ b.cartInfo.count }}</td>
                <td>
                    {{ pricingService.getCurrency() }}{{ (pricingService.getAVPricing(b.bookInfo) * b.cartInfo.count) | astreaCurrency }}
                </td>
            </tr>
        </table>
        <div class="t-right mt-3">
            <p><strong>{{ 'cart.total' | translate }}: </strong>{{ pricingService.getCurrency() }}{{ totalDigital }}</p>
            <button (click)="handleChangeTab(3)" class="btn btn-green btn-purchase mt-2" mat-button>
                {{ isLoggedIn ? ('cart.tabs.digital' | translate) : ('cart.logout' | translate) }}
            </button>
        </div>
    </div>
</div>
